export function checkIsStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((valueItem) => typeof valueItem === 'string');
}
